module.exports = __webpack_public_path__ + "img/返回.5f936044.png";